module.exports = __webpack_public_path__ + "static/atencion-98d87196de2e5da65497b72530daa28b.png";